<template>
  <el-dialog title="学期列表" :visible.sync="show" width="1100px" center :close-on-click-modal="false" :close-on-press-escape="false" :show-close="!loading" @closed="closed">
    <div class="w100" v-if="siftData.length > 0">
      <Sift ref="sift" :sift-data="siftData" :loading="loading" @change="initPage">
        <el-col :span="8">
          <el-button type="primary" :loading="loading" @click="initPage">查询</el-button>
          <el-button type="success" :loading="loading" @click="addItem">新增</el-button>
        </el-col>
      </Sift>
    </div>

    <el-table class="w100 mt10 tx-c my-table" :data="list" stripe border height="500" v-loading="loading">
      <el-table-column prop="schoolyear" label="学年" align="center"></el-table-column>
      <el-table-column label="学期" align="center">
        <template slot-scope="scope">
          <span>第{{ scope.row.semester == '1' ? '一' : '二' }}学期</span>
        </template>
      </el-table-column>
      <el-table-column label="开始时间" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.starttime | filterDate('yyyy-MM-dd') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="结束时间" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.endtime | filterDate('yyyy-MM-dd') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="最后更新" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.updatetime | filterDate('yyyy-MM-dd') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="120">
        <template slot-scope="scope">
          <span class="blue ml5 mr5 cu-p" @click="editItem(scope.row)">
            <i class="myfont icon-bianji"></i>
          </span>
          <span class="grey ml5 mr5 cu-p" @click="deleteItem(scope.row)">
            <i class="myfont icon-shanchu"></i>
          </span>
        </template>
      </el-table-column>
    </el-table>

    <div class="w100 mt20 tx-r">
      <el-pagination @size-change="changeSize" @current-change="changePage" :current-page="pageNum" :page-sizes="[20, 30, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" background :total="total"></el-pagination>
    </div>

    <CalendarTermDialogForEdit ref="calendarTermDialogForEdit" @init-page="initPage" @fetch-list="fetchList" />
  </el-dialog>
</template>

<script>
import Sift from "@/components/sift/Sift";
import CalendarTermDialogForEdit from "@/components/serveSearch/calendar/CalendarTermDialogForEdit";

export default {
  name: "TermDialog",
  components: {
    Sift,
    CalendarTermDialogForEdit
  },
  props: [],
  data() {
    return {
      baseUrl: process.env.BASE_URL,

      loading: false,
      show: false,

      siftData: [],
      list: [],
      total: 0,
      pageNum: 1,
      pageSize: 20
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    addItem() {
      this.$refs.calendarTermDialogForEdit.showView(null, false);
    },
    editItem(item) {
      this.$refs.calendarTermDialogForEdit.showView(item, true);
    },
    deleteItem(item) {
      this.$confirm("确认删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loading = true;
          this.$http
            .delete("/calendar/delete", {
              params: {
                id: item.wid
              }
            })
            .then(({ data }) => {
              if (data.resCode == "0") {
                this.$message.success(data.resMsg);
                this.fetchList();
              }
              this.loading = false;
            })
            .catch(err => {
              this.loading = false;
            });
        })
        .catch(() => {});
    },
    fetchSiftData() {
      this.loading = true;
      this.$http
        .post("/calendar/listCondition")
        .then(({ data }) => {
          if (data.resCode == "0") {
            this.siftData = data.resData;

            this.$nextTick(() => {
              this.initPage();
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    fetchList() {
      let obj = {};
      if (this.siftData.length > 0) {
        obj = this.$refs.sift.getValue();
      }
      obj.pageNum = this.pageNum;
      obj.pageSize = this.pageSize;

      this.loading = true;
      this.$http
        .post("/calendar/calendarlist", this.$qs.stringify(obj))
        .then(({ data }) => {
          if (data.resCode == "0") {
            this.list = data.resData.list;
            this.total = data.resData.total;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    changeSize(value) {
      this.pageSize = value;
      this.fetchList();
    },
    changePage(value) {
      this.pageNum = value;
      this.fetchList();
    },
    initPage() {
      this.pageNum = 1;
      this.fetchList();
    },
    showView() {
      this.show = true;
      if (this.siftData.length == 0) {
        this.$nextTick(() => {
          this.fetchSiftData();
        });
      }
    },
    closed() {
      this.$parent.getSiftData();
      this.$emit("init-page");
    }
  }
};
</script>

<style scoped>
</style>
